<template>
  <CChartLine :datasets="defaultDatasets" :options="defaultOptions" />
</template>

<script>
import firebase from "firebase";
const db = firebase.firestore();
import { CChartLine } from "@coreui/vue-chartjs";
import { getStyle, hexToRgba } from "@coreui/utils/src";

function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export default {
  name: "MainChartExample",
  components: {
    CChartLine,
  },
  data() {
    return {
      tokenList: "",
      grapdiv: [],
      allgraph: [],
      graph: [],
      options: [],
      tableData: [],
      tableData1: [],
      tokenBal: [],
      grapdata: "",
      tableToken: [],
      tokenLength: "",
      totalToken: "",
      total: 0,
    };
  },
  mounted() {
    this.$root.$on("datasent", (value) => {
      console.log("received", value);
    });
  },
  computed: {
    defaultDatasets() {
      const brandSuccess = getStyle("success") || "#4dbd74";
      const brandInfo = getStyle("info") || "#20a8d8";
      const brandDanger = getStyle("danger") || "#f86c6b";

      let elements = 3;
      const data1 = [];
      const data2 = [];
      const data3 = [];
      let tdata = [];

      
         return[{
          labels: this.grapdata,
          backgroundColor: hexToRgba(brandInfo, 10),
          borderColor: brandInfo,
          pointHoverBackgroundColor: brandInfo,
          borderWidth: 2,
          data: this.tokenBal,
        }]
    },
    defaultOptions() {
      return {
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                drawOnChartArea: false,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 5,
                stepSize: Math.ceil(200 / 5),
                max: 300,
              },
              gridLines: {
                display: true,
              },
            },
          ],
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3,
          },
        },
      };
    },
  },
  mounted(){
    this.$root.$on("datasent", (value) => {
      console.log("data",value)
      this.total = "";
      this.grapdata = value;
      console.log("main.grapdata", this.grapdata);
      this.onChange();
    });
  },
  methods: {
    assigntokenData(doc) {
      let smallDocument = {
        id: doc.id,
        name: doc.data().name,
        symbol: doc.data().symbol,
        totalSupply: doc.data().totalSupply,
        availableSupply: doc.data().availableSupply,
        companyName: doc.data().companyName,
        description: doc.data().description,
        country: doc.data().country,
        ethereum: doc.data().ethAddress,
        contract: doc.data().conAddress,
        location: doc.data().location,
        logo: doc.data().logo,
      };
      return smallDocument;
    },
    assignscaptureData(doc) {
      let smallDocument = {
        id: doc.id,
        name: doc.data().name,
        anandhToken: doc.data().anandhToken,
        huntcoin: doc.data().huntcoin,
        TRAGE: doc.data()["TRAGE Token"].length,
      };
      return smallDocument;
    },
    gettokens() {
      this.tableData = [];
      const db = firebase.firestore();
      db.collection("companyDetails1")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.tableToken.push(this.assigntokenData(doc));
            this.tokenLength = this.tableToken.length;
            this.totalToken = this.tokenLength.toString();
            let value = this.tableToken.map((n) => {
              return n.name;
            });

            this.options = value;
            console.log("this.options", this.options);
            this.getallgraphdata();
          });
        });
    },

    getallgraphdata() {
      let token = [];
      // console.log("all Data");
      db.collection("collectedCoins")
       
        .get()
        .then((snapshot) => {
          for (let doc of snapshot.docs) {
            console.log("doc", doc);
            for (let usertoken in doc.data()) {
              console.log("data", usertoken);
              if (doc.data()[usertoken].length > 0) {
                if (token[usertoken]) {
                  token[usertoken].push({
                    name: doc.id,
                    count: doc.data()[usertoken].length,
                  });
                } else {
                  token[usertoken] = [];
                  token[usertoken].push({
                    name: doc.id,
                    count: doc.data()[usertoken].length,
                  });
                }
              }
            }
          }
          this.tokenList = token;
          // console.log("token", token);
        });
    },
    onChange() {
      this.total = "";
      db.collection("collectedCoins")
        .where(this.grapdata, "!=", null)
        .get()
        .then((snapshot) => {
          for (let doc of snapshot.docs) {
            if (doc.data()[this.grapdata].length == 0) {
              this.tableData.push(doc.data()[this.grapdata].length);
              this.tokenBal = [];
            } else {
              this.tokenBal.push(doc.data()[this.grapdata].length);
              // this.total += this.tokenBal.this.grapdata.length;
            }
          }
        });
    },
  },
  created() {
      this.$on("datasent", (value) => {
      console.log("mainchart",value)
      // this.total = "";
      // this.grapdata = value;
      // console.log("main.grapdata", this.grapdata);
      // this.onChange();
    });
    
  },
};
</script>
